import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import SMCButton from '../../../../components/Simple/SMCButton';
import RowLayout from '../../../../components/Layouts/RowLayout';
import {AdministratorGetSchema} from '../../../../api/DBSchema/Administrator';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import ChangePasswordModal from '../../../PopupPages/ChangePasswordModal';
import {useBoolean} from '../../../../utils/hooks';
import Api from "../../../../api/SMPFetchHelper";
import {useSMCErrorHandler} from "../../../../utils/errorUtils";

const pageSchema = AdministratorGetSchema.pages.general;
const pageId = pageSchema.pageId;

function AdministratorGeneral({
    administratorObject,
    setAdministratorData,
    minimumPasswordLength,
    maximumPasswordLength
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const pageData = administratorObject[pageId];
    const userId    = administratorObject[AdministratorGetSchema.id];
    const setPageValue = useCallback((paramName, value) => {
        setAdministratorData([pageId, paramName], value);
    }, [setAdministratorData]);

    const firstName        = pageData[pageSchema.firstName];
    const lastName         = pageData[pageSchema.lastName];
    const title            = pageData[pageSchema.title];
    const organization     = pageData[pageSchema.organization];
    const email            = pageData[pageSchema.email];
    const additionalEmails = pageData[pageSchema.additionalEmails];
    const role             = pageData[pageSchema.role];
    const description      = pageData[pageSchema.description];

    const roleValues       = pageSchema.roleValues;

    const [isChangePasswordWindowOpen, openChangePasswordWindow, closeChangePasswordWindow] = useBoolean(false);

    return (
        <EditorLayout>
                <SMCTextInput
                    value={firstName}
                    onChange={e => setPageValue(pageSchema.firstName, e.target.value)}
                    label={t('SMP.USERS.TABLE.PAGES.FIRST_NAME')}
                    required
                />
                <SMCTextInput
                    value={lastName}
                    onChange={e => setPageValue(pageSchema.lastName, e.target.value)}
                    label={t('SMP.USERS.TABLE.PAGES.LAST_NAME')}
                    required
               />
              <SMCTextInput
                    value={title}
                    onChange={e => setPageValue(pageSchema.title, e.target.value)}
                    label={t('SMP.USERS.TABLE.PAGES.TITLE')}
                />
               <SMCTextInput
                    value={organization}
                    onChange={e => setPageValue(pageSchema.organization, e.target.value)}
                    label={t('SMP.USERS.TABLE.PAGES.COMPANY')}
                />
                <SMCTextInput
                    value={email}
                    onChange={e => setPageValue(pageSchema.email, e.target.value)}
                    label={t('SMP.USERS.TABLE.PAGES.EMAIL')}
                    required
                />
                <SMCTextInput
                    value={additionalEmails}
                    onChange={e => setPageValue(pageSchema.additionalEmails, e.target.value)}
                    label={t('SMP.USERS.TABLE.PAGES.ADDITIONAL_EMAILS')}
                    tooltip={t('SMP.USERS.TABLE.PAGES.ADDITIONAL_EMAILS.TOOLTIP')}
                />
                <SMCSelect
                    value={role}
                    label={t("SMP.ADMINISTRATORS.TABLE.ACCESS_RIGHTS")}
                    tooltip={t("SMP.ADMINISTRATORS.TABLE.ACCESS_RIGHTS.TOOLTIP")}
                    onChange={e => setPageValue(pageSchema.role, e.target.value)}
                >
                    <SMCOption value={roleValues.administrator}>{t('SMC_ADMIN_ROLE_Administrator')}</SMCOption>
                    <SMCOption value={roleValues.readOnly}>{t('SMC_ADMIN_ROLE_ReadOnly')}</SMCOption>
                    <SMCOption value={roleValues.multiDomain}>{t('SMC_ADMIN_ROLE_MultiDomain')}</SMCOption>
                    <SMCOption value={roleValues.multiDomainReadOnly}>{t('Multi Domain Read Only Administrator')}</SMCOption>
                </SMCSelect>
                <RowLayout>
                    <SMCLabel useContextWidth inline>{t('SMP.USERS.TABLE.PAGES.PASSWORD')}</SMCLabel>
                    <SMCButton onClick={openChangePasswordWindow}>{t('SMC_GEN_CHANGE')}</SMCButton>
                </RowLayout>
                <SMCTextInput
                    label={t("SMC_USER_COMMENT")}
                    value={description}
                    onChange={e => setPageValue(pageSchema.description, e.target.value)}
                />
                {/* Popup windows */}
                <ChangePasswordModal
                    isOpen={isChangePasswordWindowOpen}
                    onRequestClose={closeChangePasswordWindow}
                    //minimumLength={minUserPasswordLength}
                    //maximumLength={maxUserPasswordLength}
                    minimumLength={minimumPasswordLength}
                    maximumLength={maximumPasswordLength}
                    useMinimumLength={true}
                    useMaximumLength={true}
                    onFinish={password => {
                        Api.validateAdminUserPasswordField(userId, password)
                        .then(() => {
                            setPageValue(pageSchema.password, password);
                            closeChangePasswordWindow();
                        })
                    .catch(e => {
                        alert(getErrorMessage(e));
                    });
                    }}
                />
        </EditorLayout>
    )
}

export default AdministratorGeneral;